import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { Gateway } from "../types";

export const createGatewayQueries = (api: CoreApiClient) => {
  const { client } = api;

  const list = async (buildingId: string): Promise<Gateway[]> => {
    const { data, error } = await client.GET(`/buildings/{buildingId}/gateways`, {
      params: { path: { buildingId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    list,
    queries: createQueryKeys("gateway", {
      building: (buildingId: string) => ({
        queryKey: [buildingId],
        queryFn: () => list(buildingId),
      }),
    }),
  };
};
